import React from 'react';
import { useFusionAuth } from '@fusionauth/react-sdk';
import './UserInfoInspector.scss';
const UserInfoInspector: React.FC = () => {
  const { userInfo, isLoggedIn } = useFusionAuth();
  
  if (!isLoggedIn) {
    return <div>Not logged in</div>;
  }
  
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>User Info Inspector</h2>
      <div className = "debugUser" style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
        <pre>{JSON.stringify(userInfo, null, 2)}</pre>
      </div>
    </div>
  );
};

export default UserInfoInspector;
